export default {
  erase: 'Erase',
  eraseComponent: 'Erase Component',
  eraseSetting: 'Erase Settings',
  onlyOneTip: 'Only one erase component can be added per scene.',
  isEnable: 'Enable Component',
  enableText: 'Enabled',
  disableText: 'Disabled',
  brush: {
    title: 'Eraser Stroke Settings',
    brushStyle: 'Stroke Style',
    round: 'Circle',
    rect: 'Rectangle',
    pic: 'Image Recognition',
    size: 'Size',
    scale: 'Scale Ratio',
    rotation: 'Rotation',
    picDesc: 'Image: png, <1M',
    seqDesc: 'Sequence Frame: zip(png), <8M',
    addTip: 'Please select an image to recognize stroke style.',
    picTip: 'Recognize valid pixels in the image as strokes.',
    seqTip: 'Recognize the first frame of the sequence as strokes.',
    handImage: 'Image following fingers',
    handImageTip:
      'Eraser stroke image following finger movement during erasure',
    hangImageDialog: {
      title: 'Appearance',
      pivot: 'Anchor for Finger Trace',
      pivotDesc:
        'Green Dot as Stroke Center<br/>Move the green dot to adjust the stroke appearance',
    },
  },
  layer: {
    title: 'Component Layer',
    maskLayer: 'Mask',
    bottomImage: 'Bottom image',
    eraseableTip:
      "In this group, all images can be erased. <br />You can control whether erasing is enabled or disabled by using the switch on the right side. If it's disabled here, you can enable it again at specific times using events.",
    uneraseableTip: 'In this group, all images or gifs cannot be erased.',
    addGroup: 'Add Group',
    groupName: 'Group Name',
    groupNamePlaceholder: 'Please enter the group name.',
    groupNameEmptyWarning: 'Cannot be empty',
    eraseableTitle: 'Can it be erased?',
    eraseable: 'Erasable',
    uneraseable: 'Non-erasable',
    applyAllAnimation: 'Apply to all layers within the group',
  },
  event: {
    title: 'Event Judgment',
    when: 'Timing of Judgment',
    upTrigger: 'Judgment upon lifting finger',
    erasingTrigger: 'Real-time judgment during erasure process',
    erasingTriggerTip: 'This setting may affect performance; use with caution.',
    eraseTitleTip:
      'When a defined erasable area is erased to what percentage, an event can be triggered;<br />After completing the setup, enter the event selection to set specific response events for reaching or not reaching a certain stage.',
    addEventJudge: 'Add Event Detection',
    areaSelectTitle: 'Region Selection for Detection',
    selectAreaPlaceholder: 'Select detection area',
    addManageArea: 'Add/Manage Custom Detection Area',
    addStep: 'New Stage',
    step: 'Stage',
    stepWarning:
      'There are duplicate percentages in the judgment areas. Please modify or delete them.',
    area: {
      title: 'Custom Detection Area',
      addArea: 'Add Custom Detection Area',
      editArea: 'Edit Custom Detection Area',
      areaName: 'Name',
      areaNamePlaceholder: 'Please enter a name',
      addRect: 'Add Rectangle',
      cancel: 'Cancel',
      save: 'Save',
    },
    stepSelect: 'Stage selection',
    customEventPlaceholder: 'Select event detection',
    stepPlaceholder: 'Select a stage',
    eraseStartTip:
      'Sliding the finger on the layer of the enabled erasable group is considered as starting erasure',
    eraseUpTip: 'Lift the finger after starting erasure',
    eraseReachStepTip:
      'Please set the judgment area and stage percentage corresponding to the event judgment in the erasure settings first',
    eraseUnReachStepTip:
      'Please set the judgment area and stage percentage corresponding to the event judgment in the erasure settings first',
    addHandImage: 'Add the image following the finger',
    selectActionGroupPlaceholder: 'Select',
    selectHandImagePlaceholder: 'Select',
    selectAnimationPlaceholder: 'Select',
  },
}
